import { render, staticRenderFns } from "./userCardExport.vue?vue&type=template&id=36db6e0f&scoped=true"
import script from "./userCardExport.vue?vue&type=script&lang=js"
export * from "./userCardExport.vue?vue&type=script&lang=js"
import style0 from "./userCardExport.vue?vue&type=style&index=0&id=36db6e0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36db6e0f",
  null
  
)

export default component.exports